import ConfirmationPage from "domains/liquidity/pages/ConfirmationPage/ConfirmationPage";

export default ConfirmationPage;
